export default __webpack_public_path__ + "static/media/09.a4c357da.png";